export const RadiosEnum = {
  noBg: 'default',
  color: 'color',
  img: 'image',
};
